import React from 'react';

import {connectI18n} from '../connects';
import Blocklink from '../elements/Blocklink';
import HomeLogo from '../elements/HomeLogo';
import Input from '../elements/forms/Input';
import PleaseWait from './PleaseWait';
import Screen from './Screen';
import Scrollable from '../elements/Scrollable';
import TopBar from '../elements/TopBar/TopBar';
import {dialogAlert} from '../elements/Dialog/dialogs';

export class AddEventCode extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            code: '',
            busy: false,
            mounted: false,
        };
    }
    componentDidMount() {
        this.state.mounted = true;
        _.defer(this.focusInput.bind(this));
    }
    componentDidUpdate() {
        _.defer(this.focusInput.bind(this));
    }
    componentWillUnmount() {
        this.state.mounted = false;
    }
    render() {
        if (this.state.busy) return <PleaseWait />;

        var i18n = this.props.i18n,
            header = (
                <>
                    <TopBar returnURL="/" />
                    <HomeLogo />
                    <hr />
                </>
            );

        return (
            <Screen header={header}>
                <Scrollable>
                    <form onSubmit={this.handleSubmit.bind(this)}>
                        <h1>{i18n['label.add.event']}</h1>
                        <div className="content">
                            <Input name="code" label={i18n['label.enter.eventcode']} value={this.state.code} onChange={this.handleChange.bind(this, 'code')} />
                            <br />
                        </div>
                        <Blocklink right="right" next="next" type="submit">
                            {i18n['label.go.eventcode']}
                        </Blocklink>
                    </form>
                    <br />
                    <Blocklink right="right" next="next" href="/events/missing_code">
                        {i18n['label.not.have.eventcode']}
                    </Blocklink>
                </Scrollable>
            </Screen>
        );
    }
    handleChange(field, value) {
        this.setState({[field]: value});
    }
    handleSubmit(e) {
        e.preventDefault();

        let code = this.state.code.trim();
        if (code) {
            app.store.dispatch(app.actions.ui.busy());
            this.setState({busy: true});
            app.api.events
                .addEvent(code)
                .then(answer => {
                    app.history.push('/events/' + answer.event_id);
                    return answer;
                })
                .catch(async error => {
                    if (error?.response?.data?.added) {
                        app.history.push('/events/' + error.response.data.event_id);
                    } else if (error.response && error.response.status >= 400 && error.response.status <= 499) {
                        if (error.response?.data?.error == 'code already used') {
                            await dialogAlert(this.props.i18n['error.event-code-used']);
                        } else {
                            await dialogAlert(this.props.i18n['error.not.valid.event.code']);
                        }
                    } else {
                        console.error(error);
                    }
                })
                .then(() => {
                    app.store.dispatch(app.actions.ui.free());
                    if (this.state.mounted) {
                        this.setState({busy: false});
                    }
                });
        }
    }
    focusInput() {
        try {
            document.querySelector('input[name="code"]').focus();
        } catch (err) {
            // console.warn(err);
        }
    }
}

export default connectI18n(AddEventCode);
